import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../services/api';

export const joinCommunityAsync = createAsyncThunk(
  'community/joinCommunity',
  async ({ name, email, instagram }, { rejectWithValue }) => {
    try {
      const response = await api.post('/community', {
        name,
        email,
        instagram: instagram ? instagram.trim() : null
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        'Failed to join the community';
      return rejectWithValue(message);
    }
  }
);

const communitySlice = createSlice({
  name: 'community',
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetCommunityStatus: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(joinCommunityAsync.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(joinCommunityAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.data = action.payload?.data || action.payload;
      })
      .addCase(joinCommunityAsync.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  }
});

export const { resetCommunityStatus } = communitySlice.actions;
export default communitySlice.reducer;
